import { Injectable } from '@angular/core';
import { AgentDefinition } from '../models/agent.models';

@Injectable({ providedIn: 'root' })
export class AgentService {

  /** All agent definitions — static catalog in Phase 1 */
  readonly agents: AgentDefinition[] = [
    {
      code: 'ONBO',
      nameKey: 'chatAi.agents.onbo.name',
      descriptionKey: 'chatAi.agents.onbo.desc',
      icon: '🎓',
      accentColor: '#00897B',
      status: 'active',
      phase: 1,
      quickActions: [
        { labelKey: 'chatAi.agents.onbo.qa1', descKey: 'chatAi.agents.onbo.qa1desc', promptKey: 'chatAi.agents.onbo.qa1prompt', icon: '🚀' },
        { labelKey: 'chatAi.agents.onbo.qa2', descKey: 'chatAi.agents.onbo.qa2desc', promptKey: 'chatAi.agents.onbo.qa2prompt', icon: '📋' },
        { labelKey: 'chatAi.agents.onbo.qa3', descKey: 'chatAi.agents.onbo.qa3desc', promptKey: 'chatAi.agents.onbo.qa3prompt', icon: '⚙️' },
        { labelKey: 'chatAi.agents.onbo.qa4', descKey: 'chatAi.agents.onbo.qa4desc', promptKey: 'chatAi.agents.onbo.qa4prompt', icon: '👥' },
      ]
    },
    {
      code: 'CASH',
      nameKey: 'chatAi.agents.cash.name',
      descriptionKey: 'chatAi.agents.cash.desc',
      icon: '📊',
      accentColor: '#2E7D32',
      status: 'active',
      phase: 1,
      quickActions: [
        { labelKey: 'chatAi.agents.cash.qa1', descKey: 'chatAi.agents.cash.qa1desc', promptKey: 'chatAi.agents.cash.qa1prompt', icon: '💰' },
        { labelKey: 'chatAi.agents.cash.qa2', descKey: 'chatAi.agents.cash.qa2desc', promptKey: 'chatAi.agents.cash.qa2prompt', icon: '📈' },
        { labelKey: 'chatAi.agents.cash.qa3', descKey: 'chatAi.agents.cash.qa3desc', promptKey: 'chatAi.agents.cash.qa3prompt', icon: '👥' },
        { labelKey: 'chatAi.agents.cash.qa4', descKey: 'chatAi.agents.cash.qa4desc', promptKey: 'chatAi.agents.cash.qa4prompt', icon: '🎯' },
      ]
    },
    {
      code: 'RES',
      nameKey: 'chatAi.agents.res.name',
      descriptionKey: 'chatAi.agents.res.desc',
      icon: '⭐',
      accentColor: '#F9A825',
      status: 'locked',
      phase: 2,
      quickActions: []
    },
    {
      code: 'RRSS',
      nameKey: 'chatAi.agents.rrss.name',
      descriptionKey: 'chatAi.agents.rrss.desc',
      icon: '📱',
      accentColor: '#1565C0',
      status: 'locked',
      phase: 2,
      quickActions: []
    },
    {
      code: 'PROMO',
      nameKey: 'chatAi.agents.promo.name',
      descriptionKey: 'chatAi.agents.promo.desc',
      icon: '🎯',
      accentColor: '#E65100',
      status: 'locked',
      phase: 2,
      quickActions: []
    },
    {
      code: 'LAND',
      nameKey: 'chatAi.agents.land.name',
      descriptionKey: 'chatAi.agents.land.desc',
      icon: '🌐',
      accentColor: '#7B1FA2',
      status: 'locked',
      phase: 3,
      quickActions: []
    },
    {
      code: 'ADM',
      nameKey: 'chatAi.agents.adm.name',
      descriptionKey: 'chatAi.agents.adm.desc',
      icon: '📋',
      accentColor: '#455A64',
      status: 'locked',
      phase: 3,
      quickActions: []
    },
    {
      code: 'RISK',
      nameKey: 'chatAi.agents.risk.name',
      descriptionKey: 'chatAi.agents.risk.desc',
      icon: '⚠️',
      accentColor: '#C62828',
      status: 'locked',
      phase: 3,
      quickActions: []
    },
    {
      code: 'OPP',
      nameKey: 'chatAi.agents.opp.name',
      descriptionKey: 'chatAi.agents.opp.desc',
      icon: '🚀',
      accentColor: '#00838F',
      status: 'locked',
      phase: 3,
      quickActions: []
    },
  ];

  /** Get agent definition by code */
  getAgent(code: string): AgentDefinition | undefined {
    return this.agents.find(a => a.code === code);
  }

  /** Get the sessionStorage key for an agent's conversations */
  getStorageKey(agentCode: string | null): string {
    return agentCode
      ? `cafler.chat.agent.${agentCode}`
      : 'cafler.chat.conversations';
  }

  /** Get only active/available agents (not locked) */
  getActiveAgents(): AgentDefinition[] {
    return this.agents.filter(a => a.status !== 'locked');
  }
}
